(function($) {
    
  init()

    function init () {
    popup()
    load()
    hamburger()
    height()
    tabs()
    menuBig();
    }

    // POPUP
    function popup() {
        // POPUP
        $(document).on('click', '.what-we-do-boxes li .btn-orange', function() {
            $('body').addClass('is-popup');
            $('html').addClass('html-popup');
            $('.popup .popup-cnt-row-image .array').addClass('go');
            var activeTab = $(this).attr('href');
            $(activeTab).addClass('popup-active');
            return false;
        });
        $(document).on('click', '.popup .popup-cnt-row-back .btn-back', function() {
            $('body').removeClass('is-popup');
            $('html').removeClass('html-popup');
            $('.popup').removeClass('popup-active');
            $('.popup .popup-cnt-row-image .array').removeClass('go');
        })
    }


    // LOAD
    function load() {
        $(window).on("load", function () {
            $('.navbar nav ul li.current-menu-item a').addClass('active');
        });
    }


    // HAMBURGER
    function hamburger() {
        $('.hamburger').on('click', function() {
            $('body, html').toggleClass('menu-open');
            // $('.navbar__fixed').toggleClass('navbar__fixed-mobile');
            $('.mobile-overlay').stop().delay(300).toggleClass('open-m');
            $('.hamburger ').toggleClass('hamburger-active');
        });

        $('.mobile-overlay .menu-mobile li').on("click", function(){
            $('body, html').toggleClass('menu-open');
            // $('.navbar__fixed').toggleClass('navbar__fixed-mobile');
            $('.mobile-overlay').stop().delay(300).removeClass('open-m');
            $('.hamburger').toggleClass('hamburger-active');
            });
    }

    function height() { 
        if (window.matchMedia("(min-width: 992px)").matches) {
        var maxHeight = Math.max.apply(null, $(".contact-branches ul li .address").map(function ()                                                        {
        return $(this).innerHeight();
        }).get());      
        $(".contact-branches ul li .address").height( maxHeight );

        var maxHeightCall = Math.max.apply(null, $(".contact-branches ul li .call").map(function ()                                                        {
        return $(this).innerHeight();
        }).get());      
        $(".contact-branches ul li .call").height( maxHeightCall );

        // var marginHeight = $(".work-list ul li").prev().find('.text').height();
        // var myMargin = marginHeight - marginHeight *2;
        // $(".work-list ul li a").css('margin-top',myMargin);

        $('.work-list ul li').each(function() {
            var prevHeight = $(this).prev().find('.text').height();
            var myMargin = prevHeight - prevHeight *2;
            $(this).find('a').css('margin-top',myMargin);
          });
        }

        if (window.matchMedia("(min-width: 1200px)").matches) {
            $('.what-we-do-work ul li a').each(function() {
            var linkHeight = $(this).find('.text').height();
            var bottomMargin = linkHeight - linkHeight *2 - 40;
            $(this).hover(function() {
                $(this).find('.text').css({'transform': 'translate(' +  (30) +'px, ' + (bottomMargin) + 'px'})
            }, function() {
                $(this).find('.text').css({'transform': 'translate(' +  (0) +'px, ' + (0) + 'px'})
              });
          });
        }

      }

    // TABS 
      function tabs() {
        $(".project-list li").hide();
        $(".project-list li:nth-child(1)").show();
        $(".project-menu li a").click(function(event) {
        event.preventDefault(); // Zapobiega domyślnemu zachowaniu linku
        $(".project-menu li a").removeClass('active');
        $(this).addClass('active')
        $(".project-list li").hide();

        // Pobiera wartość atrybutu href (zakładamy, że jest to #id)
        var targetId = $(this).attr("href");

        // Znajduje div o tym id
        var targetDiv = $(targetId);

        // Sprawdza, czy div istnieje
        if (targetDiv.length > 0) {
            // Dodaje klasę 'active' do znalezionego div-a
            targetDiv.fadeIn();
        } 
    });
      } 

      // MENU BIG
    function menuBig () {
        var menu = $('body').offset().top + 200

        $(window).scroll(function() {
            if ($(this).scrollTop() >= menu) {
                $('.navbar').addClass('navbar-small');
            } else {
                $('.navbar').removeClass('navbar-small');
            }
        });
    }

    
        
    // ALL

    if ('loading' in HTMLImageElement.prototype) {
        const images = document.querySelectorAll('img[loading="lazy"]');
        images.forEach(img => {
            img.src = img.dataset.src;
        });
    } else {
        // Dynamically import the LazySizes library
        const script = document.createElement('script');
        script.src =
            'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.1.2/lazysizes.min.js';
        document.body.appendChild(script);
    }


    // PLACEHOLDER
    $('input,textarea').focus(function() {
        $(this).data('placeholder', $(this).attr('placeholder'))
        .attr('placeholder', '');
        }).blur(function() {
        $(this).attr('placeholder', $(this).data('placeholder'));
    });

}(jQuery));